import { useEffect, useState, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { Navbar } from "@/components/Navbar";
import { HeroSection } from "@/components/HeroSection";
import { WhatIDoSection } from "@/components/WhatIDoSection";
import { StatementSection } from "@/components/StatementSection";
import { ServicesSection } from "@/components/ServicesSection";
import { PackagesSection } from "@/components/PackagesSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { SocialSection } from "@/components/SocialSection";
import { WhoIWorkWithSection } from "@/components/WhoIWorkWithSection";
import { ProcessSection } from "@/components/ProcessSection";
import { ShowreelSection } from "@/components/ShowreelSection";
import { AboutSection } from "@/components/AboutSection";
import { CtaSection } from "@/components/CtaSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import AdminPage from "@/pages/AdminPage";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LandingPage = () => (
  <div className="grain min-h-screen bg-[#0A0A0A] text-[#F2F0EB]">
    <Navbar />
    <main>
      <HeroSection />
      <WhatIDoSection />
      <StatementSection />
      <ServicesSection />
      <PackagesSection />
      <TestimonialsSection />
      <SocialSection />
      <WhoIWorkWithSection />
      <ProcessSection />
      <ShowreelSection />
      <AboutSection />
      <CtaSection />
      <ContactSection />
    </main>
    <Footer />
  </div>
);

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    axios
      .post(`${API}/auth/session`, { session_id: sessionId }, { withCredentials: true })
      .then((res) => navigate("/admin", { state: { user: res.data }, replace: true }))
      .catch(() => navigate("/admin", { replace: true }));
  }, [location, navigate]);

  return <div className="min-h-screen bg-[#0A0A0A]" />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/admin" element={<AdminPage />} />
    </Routes>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    window.__scrollToId = (id) => {
      const el = document.querySelector(id);
      if (el) lenis.scrollTo(el, { duration: 1.2 });
    };
    window.__openEnquiry = (projectType) => {
      window.dispatchEvent(new CustomEvent("etia:prefill", { detail: { project_type: projectType } }));
      window.__scrollToId("#contact");
    };
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#161616", border: "1px solid rgba(242,240,235,0.12)", color: "#F2F0EB" } }} />
    </div>
  );
}

export default App;
